export function Title({ children }: any) {
  return (
    <h1 className="text-center text-3xl font-bold tracking-tight text-aegean">
      {children}
    </h1>
  );
}
